import React from "react";
import "./ButtonRectangle.scss";

const ButtonRectangle = ({ href,text }) => {
  return (
    <a href={href} className="ButtonRectangle">
      {text} &rarr;
    </a>
  );
};
export default ButtonRectangle;
